module.exports = __webpack_public_path__ + "static/img/study.1f48cfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon/my-coin/study.png
// module id = 3848
// module chunks = 1